import React, { useState, useEffect, useCallback } from 'react';
import '../../../customComponents/scoresDropDown.scss';
import { IoMdArrowDropdown } from 'react-icons/io';
import { rwidth } from 'utils/ResponsiveUtils';
import { ScoresGroupsDTO } from 'business/models/Models';

interface Props {
  defaultText: string;
  optionsList: ScoresGroupsDTO[];
  onSelectOption: (optionId: number) => void;
  dropdownHeight: string;
  dropdownwidth: string;
}
export default function ScoreGroupsDropDown(props: Props) {
  const { defaultText, optionsList, onSelectOption, dropdownHeight, dropdownwidth } =
    props;

  const [showOptionsList, setShowOptionsList] = useState<boolean>(false);
  const [defaultSelected, setDefaultSelected] = useState<string>(defaultText);

  useEffect(() => {
    setDefaultSelected(defaultText);
  }, [defaultText]);

  useEffect(() => {
    function handleClickOutside(e) {
      if (
        !e.target.classList.contains('score-select-item') &&
        !e.target.classList.contains('select-scores-top') &&
        !e.target.classList.contains('select-scores-selected') &&
        !e.target.classList.contains('scores-arrow') &&
        !e.target.classList.contains('scores-arrow-img') &&
        !e.target.classList.contains('score-select-body') &&
        !e.target.classList.contains('select-scores') &&
        !e.target.classList.contains('scores-ul')
      ) {
        setShowOptionsList(false);
      }
    }
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  });

  const getScoreGroupsView = useCallback((scoreGroups: ScoresGroupsDTO[]) => {
    return (
      <>
        {scoreGroups.map((scoregroup, index) => {
          return (
            <option
              id={`scoregroupdropdown-view-option-${scoregroup.name}`}
              key={index}
              className={'score-select-item cursor-pointer'}
              style={{ marginLeft: '20px' }}
              value={scoregroup.scoreGroupsId}
              onClick={handleOptionsClick}
            >
              {scoregroup.name}
            </option>
          );
        })}
      </>
    );
  }, []);

  const handleOptionsClick = useCallback((e): void => {
    const value = Number(e.target.value);
    setDefaultSelected(e.target.text);
    setShowOptionsList(false);
    onSelectOption(value);
  }, []);

  const handleListDisplay = useCallback((): void => {
    setShowOptionsList(!showOptionsList);
  }, []);

  return (
    <div
      id={`scoregroupdropdown-wrapper`}
      style={{
        border: 1,
        borderColor: '#414042',
        borderStyle: 'solid',
        background: '#ffffff',
        height: dropdownHeight,
        width: dropdownwidth,
      }}
    >
      <div
        id={`scoregroup-dropdown-toggle-`}
        className="select-scores-top flex-y-center flex-space-between cursor-pointer"
        onClick={handleListDisplay}
      >
        <div id="scoregroup-dropdown-selected" className="select-scores-selected flex-y-center">{defaultSelected}</div>
        <div id="scoregroup-dropdown-arrow" className="scores-arrow flex-y-center">
          <IoMdArrowDropdown
            id='scoregroup-chevron-icon'
            size={'1.2rem'}
            style={{ marginRight: rwidth(13.21) }}
          ></IoMdArrowDropdown>
        </div>
      </div>
      {showOptionsList && (
        <div id="scoregroup-dropdown-options" className="score-select-body">
          <ul id="scoregroup-dropdown-list" className="scores-ul">{getScoreGroupsView(optionsList)}</ul>
        </div>
      )}
    </div>
  );
}
